export default class LogUtils {
  constructor(debug) {
    this.enableDebug = debug
  }

  getTag(tag) {
    return tag + '===================='
  }

  setEnableDebug(debug) {
    this.enableDebug = debug
  }

  debug(msg) {
    if (this.enableDebug) {
      console.debug(msg)
    }
  }

  debugWithTag(tag, msg) {
    if (this.enableDebug) {
      console.debug(LogUtils.getTag(tag), msg)
    }
  }

  info(msg) {
    if (this.enableDebug) {
      console.info(msg)
    }
  }

  infoWithTag(tag, msg) {
    if (this.enableDebug) {
      console.info(this.getTag(tag), msg)
    }
  }

  log(msg) {
    if (this.enableDebug) {
      console.log(msg)
    }
  }

  logWithTag(tag, msg) {
    if (this.enableDebug) {
      console.log(this.getTag(tag), msg)
    }
  }

  error(msg) {
    if (this.enableDebug) {
      console.error(msg)
    }
  }

  errorWithTag(tag, msg) {
    if (this.enableDebug) {
      console.error(this.getTag(tag), msg)
    }
  }

  warn(msg) {
    if (this.enableDebug) {
      console.warn(msg)
    }
  }

  warnWithTag(tag, msg) {
    if (this.enableDebug) {
      console.warn(this.getTag(tag), msg)
    }
  }

}